import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { buildContrib59Name, getContribLegge59Control } from '../validators/helpers/contrib-legge-59-92-form.helpers';
import { debounceTime, merge, startWith } from 'rxjs';
import { numToStr, toNum } from '@shared/helpers/math.helper';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { Utilities } from '@core/helpers/utilities';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { cloneDeep } from 'lodash-es';
import { getControl } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';

export const setContribLegge59CalcoliContributoListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    const flags = [false, true];
    flags.forEach((flag) => {
        my_SommaAccantRistorniHelper(form, store, flag);
        my_UtileAlNettoDiAccantUtiRisIndHelper(form, store, flag);
        my_UtileAlNettoDiRisPerditePregrHelper(form, store, flag);
        my_BaseCalcoloHelper(form, store, flag);
        my_ImportoComplessivoHelper(form, store, flag);
    });
};

const my_SommaAccantRistorniHelper = (form: FormGroup, store: Store<Revisione53State>, isFirstYear: boolean): void => {
    const my_PreaccantonamentiControl = getContribLegge59Control(form, buildContrib59Name('my_Preaccantonamenti', isFirstYear));
    const my_AccantonamentoControl = getContribLegge59Control(form, buildContrib59Name('my_Accantonamento', isFirstYear));
    const my_EventRistorniControl = getContribLegge59Control(form, buildContrib59Name('my_EventRistorni', isFirstYear));
    const my_SommaAccantRistorniControl = getContribLegge59Control(form, buildContrib59Name('my_SommaAccantRistorni', isFirstYear));

    merge(
        my_PreaccantonamentiControl.valueChanges.pipe(startWith(my_PreaccantonamentiControl?.value ?? null)),
        my_AccantonamentoControl.valueChanges.pipe(startWith(my_AccantonamentoControl?.value ?? null)),
        my_EventRistorniControl.valueChanges.pipe(startWith(my_EventRistorniControl?.value ?? null))
    )
        .pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME))
        .subscribe(() => {
            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                const tot = (toNum(my_PreaccantonamentiControl.value) ?? 0) + (toNum(my_AccantonamentoControl.value) ?? 0) - (toNum(my_EventRistorniControl.value) ?? 0);
                const totStr = numToStr(tot);
                my_SommaAccantRistorniControl.patchValue(totStr, { emitEvent: false });
                myVerbaleClone.my_SezioneI__Rilevazione.my_ContributoLegge59[buildContrib59Name('my_SommaAccantRistorni', isFirstYear)] = totStr;
                return myVerbaleClone;
            });
        });
};

const my_UtileAlNettoDiAccantUtiRisIndHelper = (form: FormGroup, store: Store<Revisione53State>, isFirstYear: boolean): void => {
    const my_RisultEsercizioControl = getContribLegge59Control(form, buildContrib59Name('my_RisultEsercizio', isFirstYear));
    const my_EventAccantUtiRisIndControl = getContribLegge59Control(form, buildContrib59Name('my_EventAccantUtiRisInd', isFirstYear));
    const my_UtileAlNettoDiAccantUtiRisIndControl = getContribLegge59Control(form, buildContrib59Name('my_UtileAlNettoDiAccantUtiRisInd', isFirstYear));

    merge(
        my_RisultEsercizioControl.valueChanges.pipe(startWith(my_RisultEsercizioControl?.value ?? null)),
        my_EventAccantUtiRisIndControl.valueChanges.pipe(startWith(my_EventAccantUtiRisIndControl?.value ?? null))
    )
        .pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME))
        .subscribe(() => {
            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                const utileNetto = numToStr(toNum(my_RisultEsercizioControl.value) - toNum(my_EventAccantUtiRisIndControl.value));
                my_UtileAlNettoDiAccantUtiRisIndControl.patchValue(utileNetto, { emitEvent: false });
                myVerbaleClone.my_SezioneI__Rilevazione.my_ContributoLegge59[buildContrib59Name('my_UtileAlNettoDiAccantUtiRisInd', isFirstYear)] = utileNetto;
                return myVerbaleClone;
            });
        });
};

const my_UtileAlNettoDiRisPerditePregrHelper = (form: FormGroup, store: Store<Revisione53State>, isFirstYear: boolean): void => {
    const my_UtileAlNettoDiAccantUtiRisIndControl = getContribLegge59Control(form, buildContrib59Name('my_UtileAlNettoDiAccantUtiRisInd', isFirstYear));
    const my_PerditeEsercControl = getContribLegge59Control(form, buildContrib59Name('my_PerditeEserc', isFirstYear));
    const my_UtileAlNettoDiRisPerditePregrControl = getContribLegge59Control(form, buildContrib59Name('my_UtileAlNettoDiRisPerditePregr', isFirstYear));

    merge(
        my_UtileAlNettoDiAccantUtiRisIndControl.valueChanges.pipe(startWith(my_UtileAlNettoDiAccantUtiRisIndControl?.value ?? null)),
        my_PerditeEsercControl.valueChanges.pipe(startWith(my_PerditeEsercControl?.value ?? null))
    )
        .pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME))
        .subscribe(() => {
            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                const diff = toNum(my_UtileAlNettoDiAccantUtiRisIndControl.value) - toNum(my_PerditeEsercControl.value);
                const utileNettoStr = numToStr(toNum(diff > 0) * diff);
                my_UtileAlNettoDiRisPerditePregrControl.patchValue(utileNettoStr, { emitEvent: false });
                myVerbaleClone.my_SezioneI__Rilevazione.my_ContributoLegge59[buildContrib59Name('my_UtileAlNettoDiRisPerditePregr', isFirstYear)] = utileNettoStr;
                return myVerbaleClone;
            });
        });
};

const my_BaseCalcoloHelper = (form: FormGroup, store: Store<Revisione53State>, isFirstYear: boolean): void => {
    const annoEsPath = isFirstYear ? 'my_SezioneI__Rilevazione.my_Bilancio.my_AnnoSecondoEs' : 'my_SezioneI__Rilevazione.my_Bilancio.my_AnnoPrimoEs';
    const my_AnnoPrimoEsControl = getControl(form, annoEsPath);

    // Controlli per anno < 2014
    const my_RisultEsercizioControl = getContribLegge59Control(form, buildContrib59Name('my_RisultEsercizio', isFirstYear));
    const my_PreaccantonamentiControl = getContribLegge59Control(form, buildContrib59Name('my_Preaccantonamenti', isFirstYear));
    const my_AccantonamentoControl = getContribLegge59Control(form, buildContrib59Name('my_Accantonamento', isFirstYear));
    const my_PerditeEsercControl = getContribLegge59Control(form, buildContrib59Name('my_PerditeEserc', isFirstYear));
    const my_EventRistorniControl = getContribLegge59Control(form, buildContrib59Name('my_EventRistorni', isFirstYear));

    // Controlli per anno >= 2014
    const my_EventAccantUtiRisIndControl = getContribLegge59Control(form, buildContrib59Name('my_EventAccantUtiRisInd', isFirstYear));

    const my_BaseCalcoloControl = getContribLegge59Control(form, buildContrib59Name('my_BaseCalcolo', isFirstYear));

    merge(
        my_AnnoPrimoEsControl.valueChanges.pipe(startWith(my_AnnoPrimoEsControl?.value ?? null)),
        my_RisultEsercizioControl.valueChanges.pipe(startWith(my_RisultEsercizioControl?.value ?? null)),
        my_PreaccantonamentiControl.valueChanges.pipe(startWith(my_PreaccantonamentiControl?.value ?? null)),
        my_AccantonamentoControl.valueChanges.pipe(startWith(my_AccantonamentoControl?.value ?? null)),
        my_PerditeEsercControl.valueChanges.pipe(startWith(my_PerditeEsercControl?.value ?? null)),
        my_EventRistorniControl.valueChanges.pipe(startWith(my_EventRistorniControl?.value ?? null)),
        my_EventAccantUtiRisIndControl.valueChanges.pipe(startWith(my_EventAccantUtiRisIndControl?.value ?? null))
    )
        .pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME))
        .subscribe(() => {
            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                const annoPrimoEs = toNum(my_AnnoPrimoEsControl.value) ?? 0;

                let baseCalcolo: number;

                if (annoPrimoEs < 2014) {
                    // Vecchia formula
                    baseCalcolo =
                        (toNum(my_RisultEsercizioControl.value) ?? 0) +
                        (toNum(my_PreaccantonamentiControl.value) ?? 0) +
                        (toNum(my_AccantonamentoControl.value) ?? 0) -
                        (toNum(my_PerditeEsercControl.value) ?? 0) -
                        (toNum(my_EventRistorniControl.value) ?? 0);
                } else {
                    // Nuova formula >= 2014 — calcolo inline per evitare lettura di valori intermedi stale
                    const preaccantonamenti = toNum(my_PreaccantonamentiControl.value) ?? 0;
                    const accantonamento = toNum(my_AccantonamentoControl.value) ?? 0;
                    const eventRistorni = toNum(my_EventRistorniControl.value) ?? 0;
                    const somma = preaccantonamenti + accantonamento - eventRistorni;

                    const risultEsercizio = toNum(my_RisultEsercizioControl.value) ?? 0;
                    const eventAccant = toNum(my_EventAccantUtiRisIndControl.value) ?? 0;
                    const diffAccant = risultEsercizio - eventAccant;
                    const utileAccant = diffAccant > 0 ? diffAccant : 0;

                    const perdite = toNum(my_PerditeEsercControl.value) ?? 0;
                    const diffPerdite = utileAccant - perdite;
                    const utileNetto = diffPerdite > 0 ? diffPerdite : 0;

                    if (somma + utileNetto > 0) {
                        baseCalcolo = somma + eventAccant + utileNetto;
                    } else {
                        baseCalcolo = somma + eventAccant;
                    }
                }

                const baseCalcoloStr = numToStr(baseCalcolo);
                my_BaseCalcoloControl.patchValue(baseCalcoloStr, { emitEvent: false });
                myVerbaleClone.my_SezioneI__Rilevazione.my_ContributoLegge59[buildContrib59Name('my_BaseCalcolo', isFirstYear)] = baseCalcoloStr;
                return myVerbaleClone;
            });
        });
};

const my_ImportoComplessivoHelper = (form: FormGroup, store: Store<Revisione53State>, isFirstYear: boolean): void => {
    const my_BaseCalcoloControl = getContribLegge59Control(form, buildContrib59Name('my_BaseCalcolo', isFirstYear));
    const my_PercentualeVigenteControl = getContribLegge59Control(form, buildContrib59Name('my_PercentualeVigente', isFirstYear));
    const my_ImportoComplessivoControl = getContribLegge59Control(form, buildContrib59Name('my_ImportoComplessivo', isFirstYear));

    merge(
        my_BaseCalcoloControl.valueChanges.pipe(startWith(my_BaseCalcoloControl?.value ?? null)),
        my_PercentualeVigenteControl.valueChanges.pipe(startWith(my_PercentualeVigenteControl?.value ?? null))
    )
        .pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME))
        .subscribe(() => {
            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                const baseCalcolo = toNum(my_BaseCalcoloControl.value) ?? 0;
                const percentuale = toNum(my_PercentualeVigenteControl.value) ?? 0;
                const importoComplessivo = baseCalcolo >= 0 ? (baseCalcolo * percentuale) / 100 : 0;
                const importoComplessivoStr = numToStr(importoComplessivo);
                my_ImportoComplessivoControl.patchValue(importoComplessivoStr, { emitEvent: false });
                myVerbaleClone.my_SezioneI__Rilevazione.my_ContributoLegge59[buildContrib59Name('my_ImportoComplessivo', isFirstYear)] = importoComplessivoStr;
                return myVerbaleClone;
            });
        });

    if (!isFirstYear) {
        const my_ImportoVersatoControl = getContribLegge59Control(form, 'my_ImportoVersato');
        const my_CkVersamEffettControl = getContribLegge59Control(form, 'my_CkVersamEffett');

        merge(
            my_ImportoComplessivoControl.valueChanges.pipe(startWith(my_ImportoComplessivoControl?.value ?? null)),
            my_ImportoVersatoControl.valueChanges.pipe(startWith(my_ImportoVersatoControl?.value ?? null))
        )
            .pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME))
            .subscribe(() => {
                updateVerbaleOnStore(store, (myVerbale) => {
                    const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                    const bothExist = !isNilOrEmpty(my_ImportoComplessivoControl.value) && !isNilOrEmpty(my_ImportoVersatoControl.value);
                    const isEqualFloor = bothExist && Math.floor(toNum(my_ImportoComplessivoControl.value)) === Math.floor(toNum(my_ImportoVersatoControl.value));
                    my_CkVersamEffettControl.patchValue(isEqualFloor ? '1' : '0', { emitEvent: false });
                    myVerbaleClone.my_SezioneI__Rilevazione.my_ContributoLegge59.my_CkVersamEffett = isEqualFloor ? '1' : '0';
                    return myVerbaleClone;
                });
            });
    }
};
